export default "__VITE_PUBLIC_ASSET__bef9d2ba__"